var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9999 7.66666L56.0681 15.0113L68.5322 14.9883L72.3598 26.8487L82.4568 34.155L78.5832 46L82.4568 57.845L72.3598 65.1513L68.5322 77.0117L56.0681 76.9887L45.9999 84.3333L35.9316 76.9887L23.4676 77.0117L19.64 65.1513L9.54297 57.845L13.4166 46L9.54297 34.155L19.64 26.8487L23.4676 14.9883L35.9316 15.0113L45.9999 7.66666Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.583 46L42.1663 55.5833L61.333 36.4166",
    fill: "#34C759"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.583 46L42.1663 55.5833L61.333 36.4166",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.7edaf30532aca8612f37902b9fdf88a7.svg";
export { ForwardRef as ReactComponent };